export default __webpack_public_path__ + "static/media/auth-background.d4805fd9.png";